(function(angular){
'use strict';
/**
 *  We initalize main object, add modules, components and initialize config..
 *  Main things is going on in config.js, DataService.js, run.js and user-store.js
 *  read comments in this file to start with..
 *
 *  Main concept is that we use routes (defined in config.js) to show views from views/angular/views folder.. In those views,
 *  we have markup for our angular components, which consist of js code placed in js/angular/components and they are using
 *  templates from views as well.
 *  For working with user we use "ngStorage-user" which is saved in browser in "Session Storage".. All data for user like
 *  name and so on are stored in this object before user creates the login.. After login is created,
 *  user data is saved in laravel database..
 *  In DataService we define api object methods, which call Laravel API to get the data about users from Database..
 *  There are also methods for saving users..
 *  Read more documentation in config.js, run.js, DataService.js and user-store.js files.
 *
 *  For more information - read "How basic code works.." section in "Documentation - jobhaj.com.txt" document
 */
angular.element(document).ready(function (event) {

    // include Angular modules.
    var modules = [];
    modules.push('ngAria');     // needed for ngMaterial module (not sure)
    modules.push('ngMaterial'); // modules used as a main frontend library, where a lot of
    modules.push('ngAnimate');  // used to animate pages and views - look in youtube how this module can be used
    modules.push('ngRoute');    // default angularJs routing module
    modules.push('ngStorage');  // module for using Session Storage of the browser..
    modules.push('satellizer'); // used for authentication, so user can login and so on..
    modules.push('flux');       // module we use flux top call different functions throughout the application - look more on YouTube

    angular.module('demo-app', modules) // add modules to app..

        // set configuration for our angular object..
        //read config/config.js file where we set routes for the application and so on..
        .config(config)

        // Flux
        // we use flux top call different functions throughout the application
        // so we can call flux.dispatch('GET_USER'); functions for this actions are set in stores/user-store.js file
        // like store.handlers[actions.GET_USER] = 'getUser'; After this getUser is just a function in stores/user-store.js file
        .value('actions', {
            AUTHENTICATE_USER: 'AUTHENTICATE_USER',
            GET_USER: 'GET_USER',
            UPDATE_USER: 'UPDATE_USER',
            SAVE_APPLICATION: 'SAVE_APPLICATION',
            LOGOUT_USER: 'LOGOUT_USER',
            DELETE_USER: 'DELETE_USER',
        })

        .directive('login', login)
        .directive('menu', menu)
        .directive('momentize', momentize)
        .directive('keepScrollPos', keepScrollPos)
        .directive('passwordMatch', passwordMatch)
        .directive('videoResizer', videoResizer)
        .directive('scrollTo', scrollTo)
        .directive('compile', ['$compile', compileHtmlWithDirectives])
        // all components are placed in js/angular/components
        .component('applicationImage', applicationImage)
        .component('applicationInfo', applicationInfo)
        .component('applicationInterests', applicationInterests)
        .component('applicationExperience', applicationExperience)
        .component('applicationLanguages', applicationLanguages)
        .component('applicationLook', applicationLook)
        .component('applicationMotivation', applicationMotivation)
        .component('applicationPersonality', applicationPersonality)
        .component('applicationWorkhours', applicationWorkhours)
        .component('controlBar', controlBar)
        .component('infoForm', infoForm)
        .component('interestsForm', interestsForm)
        .component('jobhajApplication', jobhajApplication)
        .component('jobhajDialog', jobhajDialog)
        .component('jobhajProfile', jobhajProfile)
        .component('languagesForm', languagesForm)
        .component('motivationForm', motivationForm)
        .component('photoUploader', photoUploader)
        .component('smileyForm', smileyForm)
        .component('stepIndicator', stepIndicator)
        .controller('DialogCtrl', DialogCtrl)
        .controller('HelpDialogCtrl', HelpDialogCtrl)
        .controller('showJobMapDialogCtrl', showJobMapDialogCtrl)
        // .controller('SendDialogCtrl', SendDialogCtrl)
        .factory('Breakpoints', Breakpoints)
        .factory('DataService', DataService)
        .factory('Tracking', Tracking)
        // run stores/user-store.js file..
        // or more correctly said, we set store object for angular to a object, which is returned by userStore function,
        // which is placed in stores/user-store.js file
        .store('userStore', userStore)
        .animation('.intro', intro)
        // finally we call config/run.js file
        // there we save all functions, which is running on application load - check if user is authenticated and so on
        .run(run);

    // Bootstrap manually
    angular.bootstrap(document.getElementById('ng-app'), ['demo-app']);
});
/**
 * @ngInject
 */

function intro() {

    return {
        addClass : function (elem, className, done) {
        },
        removeClass : function (elem, className, done) {
            if (className === 'ng-hide'){
                
                // Animation here
            }
        }
    }
}
/**
 * This component lets person to add previous job experiences.
 * in the end we form en array ctrl.user.experience, which consist of objects containing:
 *  - jobId - unique identifier, so job can be removed as well by it. It is also added as person can add few simular titles, so we can not
 *     use jobtitle to identify job with.
 *  - jobTitle - like "Kasse medarbejder"
 *  - employmentDuration - string like "0 - 6 months"
 *
 *
 * @type {{bindings: {}, controller: applicationExperience.applicationExperienceCtrl, templateUrl: application-experience.component.html}}
 */
var applicationExperience = {
    bindings : {
    },
    controller : function applicationExperienceCtrl ($scope, $sce, $timeout, $location, flux, actions, userStore) {
        
        var ctrl = this;
        var formData = {};

        ctrl.step = 0;
        ctrl.messages = [];
        ctrl.totalSteps = [0,1,2,3];

        ctrl.selectedJobTypeId = null;
        ctrl.selectedTitle = '';
        ctrl.jobTypes = [
            {
                id: '0',
                title: 'Restaurant og cafe',
                selected: false,
                titles: [
                    'Tjener',
                    'Ekspedient',
                    'Opvasker',
                    'Afrydder',
                    'Cafemedarbejder',
                    'Køkkenassistent',
                    'Garderobemedarbejder',
                    'Andet'
                ]
            },
            {
                id: '1',
                title: 'Butik',
                selected: false,
                titles: [
                    'Ekspedient',
                    'Salgsassistent',
                    'Butiksassistent',
                    'Kundemedarbejder',
                    'Butiksmedarbejder',
                    'Andet'
                ]
            },
            {
                id: '2',
                title: 'Supermarked og kiosk',
                selected: false,
                titles: [
                    'Servicemedarbejder',
                    'Salgsassistent i supermarked',
                    'Butiksassistent i supermarked',
                    'Kassemedarbejder',
                    'Butiksekspedient',
                    'Andet'
                ]
            },
            {
                id: '3',
                title: 'Lager',
                selected: false,
                titles: [
                    'Lagermedarbejder',
                    'Ungarbejder på lager',
                    'Andet'
                ]
            },
            {
                id: '4',
                title: 'Rengøring',
                selected: false,
                titles: [
                    'Rengøringsassistent',
                    'Rengøringsmedarbejder',
                    'Andet'
                ]
            },
            {
                id: '5',
                title: 'Salg og marketing',
                selected: false,
                titles: [
                    'Salgsmedarbejder',
                    'Telesælger',
                    'Phoner',
                    'Facer',
                    'Callcenter-medarbejder',
                    'Andet'
                ]
            },
            {
                id: '6',
                title: 'Transport',
                selected: false,
                titles: [
                    'Chauffør',
                    'Cykelbud',
                    'Avisomdeler',
                    'Reklameomdeler',
                    'Andet'
                ]
            },
            {
                id: '7',
                title: 'Børn og ældre',
                selected: false,
                titles: [
                    'Barnepige',
                    'Køkkenmedhjælper i daginstitution',
                    'Aktivitetsmedarbejder',
                    'Andet'
                ]
            },
            {
                id: 'other',
                title: 'Andet',
                selected: false
            }
        ];
        ctrl.duration = 0;
        // should duration be saved as "måned" or "måneder"..
        ctrl.monthForm = 'måneder';

        function init () {
            // we get user data available in local store
            ctrl.user = userStore.getUser();

            // if user have already some experience filled out, we go directly to step 1 and not ask user again if he had job before.
            if (ctrl.user.experience !== undefined && ctrl.user.experience !== 'none' && ctrl.user.experience.length !== 0) {
                ctrl.next();
            }
        }

        function link () {
            // we show a first welcome message to a user when element is loaded
            if (ctrl.step === 0){
                $timeout(function() {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Har du haft et fritidsjob før? 😎 Tryk ja, hvis du har og nej, hvis du ikke har 👌'),
                        type: 'receive'
                    });
                }, 500);
            }
        }

        // going to certain step
        ctrl.goToStep = function(step){
            ctrl.step = step;
            // console.log('goToStep func');
            // console.log('ctrl.step');
            // console.log(ctrl.step);
            // console.log('--------- END goToStep func ---------');

            // show message for current step
            showStepMessage();
        };

        // going to next step
        ctrl.next = function(){
            ctrl.step++;
            // console.log('--- next func ---');
            // console.log('ctrl.step');
            // console.log(ctrl.step);

            // show message for current step
            showStepMessage();
        };

        // going to previous step
        ctrl.previous = function(){

            if (ctrl.step === 3 && ctrl.selectedJobTypeId === 'other') {
                ctrl.goToStep(2.5);
            } else {
                ctrl.step--;
            }

            // show message for current step
            showStepMessage();
        };

        // form submit of first step - choose job type - "Supermarket", "Slagter", etc.
        ctrl.submitJobTypeForm = function(){
            // if form got  submitted without selectedJobTypeId value, we show message
            if (ctrl.selectedJobTypeId === null){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge en jobtype.'),
                    type: 'receive'
                });
            } else {
                // if form is submitted with "normal" value, we go to "choose jobtitle" step, otherwise we show a step for custom jobtitle.
                if (ctrl.selectedJobTypeId === 'other'){
                    // we reset title, in case user went back and have chosen existing jobtitle before.
                    ctrl.selectedTitle = '';
                    // show step 2.5
                    ctrl.goToStep(2.5);
                } else {
                    ctrl.next();
                }
            }
        };

        // form submit of second step - choose job title
        // this form is used both for step 2.5 and for step 3
        ctrl.submitJobTitleForm = function(){
            // console.log('submitJobTitleForm');
            // console.log('ctrl.selectedTitle');
            // console.log(ctrl.selectedTitle);

            // if selected title is empty, we show warning message
            if (ctrl.selectedTitle === ''){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge en job titel.'),
                    type: 'receive'
                });
            } else {
                // Among existing job titles, we always in each category have a value "Andet". If this value is selelcted, it means
                // user want to add a custom title. Then we reset the current title value and show custom form.
                if (ctrl.selectedTitle === 'Andet') {
                    ctrl.selectedTitle = '';
                    ctrl.goToStep(2.5);
                } else {
                    // if form was submitted in step 2.5, which is custom job title step, we send user directly to step 3.
                    // if form was submitted on step 2, we just use "next" function to go to step 3.
                    // next function does "step++", and that's why we we can not use it in step 2.5, as it will result in step 3.5
                    // which does not exists
                    if (ctrl.step === 2.5){
                        ctrl.goToStep(3);
                    } else {
                        ctrl.next();
                    }
                }
            }
        };

        //  form submit of third step - choose job duration
        ctrl.selectJobDuration = function(){

            // if no duration is not selected, show a message
            if (ctrl.duration === 0){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge hvor lang tid har du arbejdet som "' + ctrl.selectedTitle + '".'),
                    type: 'receive'
                });
            } else {

                if (ctrl.duration === 1) {
                    ctrl.monthForm = 'måned';
                }
                // show users "Job experience" data
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Du har valgt, at du har arbejdet som "' + ctrl.selectedTitle +'" i ' + ctrl.duration + ' ' + ctrl.monthForm + ' 🤗'),
                    type: 'send'
                });

                // ask about confirmation
                $timeout(function() {
                    ctrl.addMsg({
                        content: '<div>Det ser rigtig god ud. <a ng-click="$ctrl.stepConfirm()">Godkend dit valg ved at trykke her.</a><div>',
                        type: 'receive'
                    });
                }, 1000);
            }
        };

        // function which is called, when user confirms his selection by clicking $ctrl.stepConfirm() or directly in step "0"
        // function saves user data using "flux.dispatch"
        ctrl.saveUserData = function(experience){

            // if user does not have job experience, he can choose "No" during step "0" and we can set experience to none.
            if (experience === 'none') {
                formData.experience = experience;
            } else {
                // if we come here, user have confirmed his selection
                // define formData.experience object based on ctrl.user.experience value, which can be - "none", array, undefined or empty string ""
                if (ctrl.user.experience === '' || ctrl.user.experience === undefined || ctrl.user.experience === 'none') {
                    formData.experience = [];
                } else {
                    formData.experience = ctrl.user.experience;
                }

                // generate random Id with 4 letters
                var uniqueId = false;
                var jobId;
                while(!uniqueId) {
                    jobId = makeId();
                    // check with lodash if object with this id already exists..
                    var jobExperienceExistingObj = _.find(formData.experience, function(e) { return e.id === jobId; });
                    if (jobExperienceExistingObj === undefined) {
                        uniqueId = true;
                    }
                }

                // durationFormatted will form a string like "2 år 5 måneder"
                var durationFormatted = '';
                var years = Math.floor(ctrl.duration / 12);
                var months = ctrl.duration % 12;
                if (years > 0) {
                    durationFormatted = years + ' år og ';
                }
                if (months > 0) {
                    durationFormatted = durationFormatted + months + ' ' + ctrl.monthForm;
                }

                // add experience item
                formData.experience.push({
                    id: jobId,
                    jobTitle: ctrl.selectedTitle,
                    employmentDuration: durationFormatted
                });
            }

            // save user data with UPDATE_USER action, which expects formData object.
            flux.dispatch(actions.UPDATE_USER, formData);

            // redirect to main application page
            $location.path( "/din-ansoegning#!" );
        };

        // message is added to ctrl.messages array
        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };
        
        // show message for current step
        function showStepMessage() {
            // we need to reset messages array if we come to the next step
            ctrl.messages = [];
            switch(ctrl.step){
                case 1:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Fedt! Det er altid godt med joberfaring! 👍 Vælg hvor du tidligere har arbejdet. Hvis jobbet ikke står på listen, så tryk på "Andet"'),
                        type: 'receive'
                    });
                    break;
                case 2:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Spændende. Hvad lavede du på jobbet? 🙂👏<br /> Vælg en jobtitel, der passer. Hvis der ikke er en titel, der passer, så klik på "Andet"'),
                        type: 'receive'
                    });
                    break;
                case 2.5:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Havde du en anden jobtitel, for eksempel piccoline, fabriksmedarbejder, sæsonmedarbejder, så skriv den i feltet nedenunder 🙂'),
                        type: 'receive'
                    });
                    break;
                case 3:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Hvor lang tid arbejdede du der? 😮✌'),
                        type: 'receive'
                    });
                    break;
            }
        }

        // generate random string to be used as job experience Id
        function makeId() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-!+£$%&";

            for (var i = 0; i < 4; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

        ctrl.$onInit = init;
        ctrl.$postLink = link;

    },
    templateUrl: './angular/components/application-experience.component.html'
};
var applicationImage = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationImageCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {

        var ctrl = this;
        ctrl.messages = [];
        ctrl.step = 0;
        ctrl.totalSteps = [0,1];
        ctrl.photoUploaderModel = {};

        var message;
        var formData = {};

        function init () {
            ctrl.user = userStore.getUser();
            // console.log("init", ctrl.user);
            ctrl.photoUploaderModel.photo = ctrl.user.photo ? ctrl.user.photo : null;
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg et godt billede af dig selv, som er passende 🤳'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            // console.log("onUserUpdated", userStore.getUser());

            if(angular.isDefined( userStore.getUser().photo )){
                if(userStore.getUser().photo != ctrl.photoUploaderModel.photo){
                    // console.log("SET PHOTO: ", userStore.getUser().photo);
                    ctrl.photoUploaderModel.photo = userStore.getUser().photo;
                }
            }

            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.next = function next(){
            ctrl.step++;
            ctrl.messages = [];
        };

        ctrl.submitImage = function submitImage() {
            if(!_.isEmpty(ctrl.photoUploaderModel.name)) {
                formData.photo = ctrl.photoUploaderModel.base64type + "," + ctrl.photoUploaderModel.base64data;
                formData.orientation = ctrl.photoUploaderModel.orientation;
                flux.dispatch(actions.UPDATE_USER, formData);
            } else {
                if (ctrl.photoUploaderModel.photo !== null) {
                    $location.path( "/din-ansoegning#!" );
                } else {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Ups du skal vælge et billede af dig selv'),
                        type: 'receive'
                    });
                    $("html, body").animate(
                        { scrollTop: 0 },
                        "slow"
                    );
                }
            }
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-image.component.html',
};
var applicationInfo = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationInfoCtrl ($scope, $sce, $location, $timeout, userStore) {
        var ctrl = this;
        var message;
        ctrl.messages = [];
        ctrl.step = 0;
        ctrl.totalSteps = [0,1];

        function init () {
            
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Her er en guide til at vælge den rigtige e-mail 😎'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.next = function next(){
            ctrl.step++;
            ctrl.messages = [];
            ctrl.addMsg({
                content: $sce.trustAsHtml('For at arbejdspladsen ved hvem du er, skriv her'),
                type: 'receive'
            });
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-info.component.html',
};
var applicationInterests = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationInterestsCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {

        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hey! Velkommen til! Vælg 3 af dine interesser 👻'),
                    type: 'receive'
                });
            }, 500);
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

    },
    templateUrl: './angular/components/application-interests.component.html',
};
var applicationLanguages = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationLanguagesCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {

        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hej! Nu skal du fortælle lidt om, hvilke sprog du taler. Vælg minimum 1 sprog og maksimum 5 🌎'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                // $timeout(function() {
                //     $location.path('/din-ansoegning');
                // }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-languages.component.html',
};
var applicationLook = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationWorkhoursCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {
        var ctrl = this;
        var message;
        var formData = {};
        ctrl.messages = [];
        ctrl.looks = [
            {
                title: 'Klassisk',
                value: 'klassisk',
                id: 'klassisk'
            },
            {
                title: 'Stilet',
                value: 'stilet',
                id: 'stilet'
            }
        ];

        function init () {
            ctrl.user = userStore.getUser();
            ctrl.look = ctrl.user.look ? ctrl.user.look : '';
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg hvordan din ansøgning skal se ud 👀'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.submitLook = function submitLook() {
            if(ctrl.look != "") {
                formData.look = ctrl.look;
                flux.dispatch(actions.UPDATE_USER, formData);
            } else {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hov! Du skal vælge et udseende.'),
                    type: 'receive'
                });
            }
            
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-look.component.html',
};
var applicationMotivation = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationMotivationCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {

        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hej! Nu skal du fortælle lidt om din motivation. Vælg 3 grunde til at du gerne vil have et job 💪'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                // $timeout(function() {
                //     $location.path('/din-ansoegning');
                // }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-motivation.component.html',
};
var applicationPersonality = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationPersonalityCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {
            ctrl.user = userStore.getUser();
        }

        function link () {
            $timeout(function() {
                if(!_.isEmpty(ctrl.user.smilies)) {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Du har udfyldt dette step før. Vælg 3 nye smileys der beskriver dig 😁'),
                        type: 'receive'
                    }); 
                } else {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Hey! Velkommen til! Vælg 3 smileys, der beskriver dig som person 😁'),
                        type: 'receive'
                    }); 
                }
                
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                // $timeout(function() {
                //     $location.path('/din-ansoegning');
                // }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user', 'personality'], onUserUpdated);

    },
    templateUrl: './angular/components/application-personality.component.html',
};
var applicationWorkhours = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationWorkhoursCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {
        var ctrl = this;
        var message;
        var formData = {};
        ctrl.messages = [];

        function init () {
            ctrl.user = userStore.getUser();
            ctrl.hours = ctrl.user.workhours ? ctrl.user.workhours : 2;
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg hvor mange timer du kan arbejde om ugen 💪 💦'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.submitWorkhours = function submitWorkhours() {
            formData.workhours = ctrl.hours;
            flux.dispatch(actions.UPDATE_USER, formData);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-workhours.component.html',
};
var controlBar = {
    bindings : {},
    /**
     * @ngInject
     */
    controller : function ControlBarCtrl ($scope, $auth, $mdDialog, flux, userStore, Tracking) {
        
        var ctrl = this;
        ctrl.isAuthenticated = false;

        function init () {

        }

        function link () {
        }

        ctrl.showJobMapPopup = function help(ev) {
            $mdDialog.show({
                controller: showJobMapDialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/job-map-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false
            });
        };

        ctrl.help = function help(ev) {
            $mdDialog.show({
                controller: HelpDialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/help-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false
            });
            Tracking.trackEvent("footer","hjaelp","");
        };

        ctrl.seeApplication = function seeApplication(ev) {
            if($auth.isAuthenticated()) {
                var win = window.open('/min-ansoegning?token=' + $auth.getToken(), '_blank');
                win.focus();
                Tracking.trackEvent("footer","se ansoegning","");
            } else {
                ctrl.login(ev);
            }
        };

        ctrl.login = function login(ev) {
            $mdDialog.show({
                controller: DialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false,
                locals: {
                    state: 'create',
                    successBtnState: 'see-application'
                }
            });
        };

        function authCallback(response){
            ctrl.isAuthenticated = $auth.isAuthenticated();
        }

        ctrl.$onInit = init;
        ctrl.$postLink = link;
        $scope.$listenTo(userStore, ['authenticated'], authCallback);
    },
    templateUrl : './angular/components/control-bar.component.html'
};
var jobhajDialog = {
    bindings : {
        messages: '<',
        messagesLength: '<',
        dialogClass: '@',
        stepConfirm: '&'
    },
    /**
     * @ngInject
     */
    controller : function JobhajDialogCtrl ($element) {
        
        var ctrl = this;

        function init () {
            // console.log("dialogClass: ", ctrl.dialogClass);
        }

        function link () {
        }

        function scrollToBottom() {
            var dialogComponent = $element[0].querySelector('.dialog-component');
            var dialogFlex = $element[0].querySelector('.dialog-flex');
            var offsetY = 20;
            TweenMax.to(dialogComponent, 0.2, {scrollTo:{y: dialogFlex.offsetHeight - dialogComponent.offsetHeight + offsetY} });
        }

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = scrollToBottom;
    },
    templateUrl : './angular/components/dialog.component.html'
};
var infoForm = {
	bindings: {
		addMsg: '&'
	},
	/**
     * @ngInject
     */
	controller: function InfoFormCtrl($sce, flux, actions, userStore){
		var ctrl = this;
		ctrl.formData = {};
		ctrl.minDate = new Date(1980, 1, 1);
		ctrl.maxDate = new Date(new Date().getFullYear() - 10, 0, 0);
		
		function init(){
			ctrl.user = userStore.getUser();
			ctrl.formData.name = ctrl.user.name ? ctrl.user.name : '';
			ctrl.formData.birthday = ctrl.user.birthday ? new Date(ctrl.user.birthday) : new Date();
			ctrl.formData.email = ctrl.user.email ? ctrl.user.email : '';
			ctrl.formData.phone = ctrl.user.phone ? ctrl.user.phone : ''; 
		}

		function link(){
		}

		ctrl.submitForm = function submitForm(valid){
			if(valid) {
				flux.dispatch(actions.UPDATE_USER, ctrl.formData);
			} else {
				// ctrl.messages = [];
				// ctrl.addMsg({
				//     $event: {
				//         content: $sce.trustAsHtml('Ups, du mangler at udfylde nogle felter.'),
				//         type: 'receive'
				//     }
				// });
			}
		};

		ctrl.$onInit = init;
		ctrl.$postLink = link;

	},
	templateUrl: './angular/components/info-form.component.html'
};
var interestsForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function InterestsFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedInterests = [];
        ctrl.interests = [
            {
                id: 'cooking',
                label: 'Madlavning',
                selected: false
            },
            {
                id: 'creative',
                label: 'Kreativ',
                selected: false
            },
            {
                id: 'dance',
                label: 'Dans',
                selected: false
            },
            {
                id: 'friendship',
                label: 'Venskab',
                selected: false
            },
            {
                id: 'gaming',
                label: 'Computerspil',
                selected: false
            },
            {
                id: 'listening_music',
                label: 'Lytte til musik',
                selected: false
            },
            {
                id: 'movie',
                label: 'Film',
                selected: false
            },
            {
                id: 'outdoor',
                label: 'Naturen',
                selected: false
            },
            {
                id: 'playing_music',
                label: 'Spille musik',
                selected: false
            },
            {
                id: 'reading',
                label: 'Læse',
                selected: false
            },
            {
                id: 'shopping',
                label: 'Shopping',
                selected: false
            },
            {
                id: 'sport',
                label: 'Sport',
                selected: false
            },
            {
                id: 'tech',
                label: 'Teknologi',
                selected: false
            },
            {
                id: 'theater',
                label: 'Teater',
                selected: false
            },
            {
                id: 'traveling',
                label: 'Rejser',
                selected: false
            },


        ];
       

        function init () {
        }

        function link () {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedInterests.length === 3) {
                formData.interests = selectedInterests;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="interests-icon '+selectedInterests[0]+'"></span><span class="interests-icon '+selectedInterests[1]+'"></span><span class="interests-icon '+selectedInterests[2]+'"></span>'),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Hold da op, hvor er du sej! <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 interesser.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onInterestsChange = function onInterestsChange(target){
            if(selectedInterests.length == 3) {
                target.selected = false;
            }
            selectedInterests = _.chain(ctrl.interests).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
    },
    templateUrl: './angular/components/interests-form.component.html',
};
var jobhajApplication = {
	bindings: {},
	/**
     * @ngInject
     */
	controller: function JobhajApplicationCtrl($scope, $route, $timeout, $sce, $auth, flux, actions, userStore, $location){
		var ctrl = this;
		var size;
		ctrl.messages = {
			intro: [],
			motivation: [],
			login: [],
			look: [],
			experience: [],
			jobMap: []
		};
		// objects to show job experiences in overview card.
        ctrl.jobPlaceholders = [];
        // defines if user has chosen an experience (chosen No or some value)
        ctrl.isExperienceSubmitted;

		function init(){
            ctrl.user = userStore.getUser();

			// update "complete" class for "experience" block on main application page
            // it controls "+" button on this block as well
            checkExperienceSubmitted();
		}

		function link(){
			var size = 0;
			if(ctrl.user.photo) {
				size++;
			}
			if(ctrl.user.email && ctrl.user.phone && ctrl.user.birthday && ctrl.user.name) {
				size++;
			}
			if(ctrl.user.smilies) {
				size++;
			}
			if(ctrl.user.motivation) {
				size++;
			}
			if(ctrl.user.interests) {
				size++;
			}
			if(ctrl.user.experience) {
				size++;
			}
			if(ctrl.user.languages) {
				size++;
			}
			if(ctrl.user.workhours) {
				size++;
			}
			if(ctrl.user.look) {
				size++;
			}

            // Messages which runs on init() by default always
			$timeout(function() {
			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Jo mere du udfylder din ansøgning, jo bedre bliver din ansøgning 🤓'),
			        type: 'receive'
			    }, 'motivation');

			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Hvis du allerede har en Jobhaj-bruger, så husk at logge ind oppe i menuen 🤓'),
			        type: 'receive'
			    }, 'login');

			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Har du haft et fritidsjob før, så tilføj det her 👌'),
			        type: 'receive'
			    }, 'experience');
			}, 500);
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Her kan du finde ledige job i nærheden af dig. Tryk på knappen for at se mere 😊'),
                    type: 'receive'
                }, 'jobMap');
            }, 2500);


			// Messages which runs on init() depending on size - how many steps have user have passed?
			if(!size) {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('Hej! 👋 Her kan vi lave din ansøgning sammen 😊'),
				        type: 'receive'
				    }, 'intro');
				}, 500);
			} else {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('Hej! 👋 Godt klaret! Du har udfyldt '+size+' ud af 9 trin 😇'),
				        type: 'receive'
				    }, 'intro');
				}, 500);
			}

			// "Look" section messages
			if(angular.isUndefined(ctrl.user.look)) {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('💅 Til sidst kan du vælge udseendet til din ansøgning'),
				        type: 'receive'
				    }, 'look');
				}, 500);
			} else {
				$timeout(function() {
					if($auth.isAuthenticated()) {
						ctrl.addMsg({
					        content: $sce.trustAsHtml('Wow! Godt klaret! 👏 Det bliver en flot ansøgning'),
					        type: 'receive'
					    }, 'look');
					} else {
						ctrl.addMsg({
					        content: $sce.trustAsHtml('Wow! Godt klaret! 👏 Husk at gemme din ansøgning'),
					        type: 'receive'
					    }, 'look');
					}
					
				}, 500);
			}
		}

		// update scope user, when user in store is updated
		function onUserUpdated() {
			ctrl.user = userStore.getUser();

            // fill up previous experiences
            getUserExperiences();

            // update "complete" class for experience block
			// it controls "+" button on this block as well.
            checkExperienceSubmitted();
 		}

 		// function to fill up object ctrl.jobPlaceholders
 		function getUserExperiences() {
            var userExperience = ctrl.user.experience;
            ctrl.jobPlaceholders = [];

            for (var i = 0; i < 3; i++) {
                // if item in array is not "undefined", we add this item to array, otherwise add empty object
                if (userExperience !== undefined && userExperience !== 'none' && userExperience[i]) {
                    ctrl.jobPlaceholders.push(
                        {
                            id: userExperience[i].id,
                            jobTitle: userExperience[i].jobTitle,
                        }
                    );
                } else {
                    ctrl.jobPlaceholders.push(
                        {
                            id: null,
                            jobTitle: 'Tilføj joberfaring'
                        }
                    );
                }
            }
        }

        // function to update isExperienceSubmitted variable, which is responsible for "+" btn and "complete" class
		// state on experience block
        function checkExperienceSubmitted() {
			// reset value on each check
			ctrl.isExperienceSubmitted = false;

            var userExperience = ctrl.user.experience;
            if ( Array.isArray(userExperience) && userExperience.length !== 0 ) {
				ctrl.isExperienceSubmitted = true;
            }
            if (userExperience === "none") {
				ctrl.isExperienceSubmitted = true;
            }
        }

 		// default Angular life circle hooks
		ctrl.$onInit = init;
		ctrl.$postLink = link;

		// remove job experience from ctrl.user.experience array by its Id
		ctrl.removeJobExperience = function (expId) {
            var formData = {};

            // remove item by id from ctrl.user.experience array
            _.remove(ctrl.user.experience, function(e) { return e.id == expId; });

            // update formData object
            formData.experience = ctrl.user.experience;

            // save user data with UPDATE_USER action, which expects formData object.
            flux.dispatch(actions.UPDATE_USER, formData);

            // redirect to main application page
            $location.path( "/din-ansoegning#!" );
        };

		ctrl.addMsg = function addMsg(message, arrayName) {
		    message = {
		        content: message.content,
		        type: message.type
		    };
		    ctrl.messages[arrayName].push(message);
		};

		$scope.$listenTo(userStore, ['user'], onUserUpdated);
	},
	templateUrl: './angular/components/jobhaj-application.component.html'
};
var jobhajProfile = {
	bindings: {},
	/**
     * @ngInject
     */
	controller: function JobhajProfileCtrl($scope, $element, $sce, $timeout, userStore, $auth, flux, actions, DataService){

		var ctrl = this;
		var user;
		var pendingUpdate = false;
		ctrl.formData = {};
		ctrl.deleteState = 0;
		ctrl.messages = [];

		function init(){
			user = userStore.getUser();
			ctrl.formData.email = user.email;
		}

		function link(){

		}

		function onUserUpdated(data) {
			ctrl.user = userStore.getUser();
			if(!_.isEmpty(data)) {
				// console.log("JobhajProfileCtrl::onUserUpdated", data);
				
				if(pendingUpdate) {
					ctrl.addMsg({
					    content: $sce.trustAsHtml('Dine ændringer er blevet gemt 👊 💦'),
					    type: 'receive'
					});
					pendingUpdate = false;
					if(!$scope.$$phase) {
						$scope.$digest();
					}
					// ctrl.profileForm.$setPristine();
					// ctrl.profileForm.$setUntouched();
				}
			}

			
			if(!$auth.isAuthenticated()){
				window.location.href = "/";
			}
		}

		ctrl.updateUser = function updateUser(isValid) {
			// console.log('updateUser', isValid);
			// if (ctrl.validateRepeatPassword(ctrl.formData.password, ctrl.formData.password_confirmation)) {
					if (isValid) {
						// console.log("updateUser::timeout::if", isValid);
						ctrl.messages = [];
						flux.dispatch(actions.UPDATE_USER, ctrl.formData);
						pendingUpdate = true;
					}
				
			// }
		};

		ctrl.addFacebook = function addFacebook() {
			flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
		};

		ctrl.deleteProfile = function deleteProfile(state) {
			// console.log(state);
			ctrl.deleteState = state;
			if(ctrl.deleteState == 2){
				flux.dispatch(actions.DELETE_USER);
			}
		};

		// ctrl.validateRepeatPassword = function validateRepeatPassword(password, repeatPassword) {
		// 	console.log('validateRepeatPassword', password);
		// 	console.log('validateRepeatPassword', repeatPassword);
		// 	if (password === repeatPassword) {
		// 		ctrl.profileForm.password_confirmation.$setValidity('repeat-password', true);
		// 		return true;
		// 	}
		// 	ctrl.profileForm.password_confirmation.$setValidity('repeat-password', false);
		// 	return false;
		// };

		ctrl.addMsg = function addMsg(message) {
		    message = {
		        content: message.content,
		        type: message.type
		    };
		    ctrl.messages.push(message);
		};

		ctrl.$onInit = init;
		ctrl.$postLink = link;

		$scope.$listenTo(userStore, ['user'], onUserUpdated);

	},
	templateUrl: './angular/components/jobhaj-profile.component.html'
};
var languagesForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function LanguagesFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedLanguages = [];
        ctrl.languages = [
            {
                id: 'Arabisk',
                selected: false
            },
            {
                id: 'Dansk',
                selected: false
            },
            {
                id: 'Engelsk',
                selected: false
            },
            {
                id: 'Fransk',
                selected: false
            },
            {
                id: 'Italiensk',
                selected: false
            },
            {
                id: 'Japansk',
                selected: false
            },
            {
                id: 'Kinesisk',
                selected: false
            },
            {
                id: 'Norsk',
                selected: false
            },
            {
                id: 'Persisk',
                selected: false
            },
            {
                id: 'Polsk',
                selected: false
            },
            {
                id: 'Portugisisk',
                selected: false
            },
            {
                id: 'Russisk',
                selected: false
            },
            {
                id: 'Spansk',
                selected: false
            },
            {
                id: 'Somali',
                selected: false
            },
            {
                id: 'Svensk',
                selected: false
            },
            {
                id: 'Tyrkisk',
                selected: false
            },
            {
                id: 'Tysk',
                selected: false
            },
            {
                id: 'Ukrainsk',
                selected: false
            },
            {
                id: 'Urdu',
                selected: false
            }
        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedLanguages.length >= 1) {
                formData.languages = selectedLanguages;
                var messages = _.map(selectedLanguages, function(value, key){
                    return '<span class="text-answer">'+value+'</span>';
                });
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml(messages.join('')),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Du har virkelig sprogøre! Det skal du nok få brug for <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge minimum 1 sprog.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onLanguageChange = function onLanguageChange(target){
            if(selectedLanguages.length == 5) {
                target.selected = false;
            }
            selectedLanguages = _.chain(ctrl.languages).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/languages-form.component.html',
};
var motivationForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function MotivationFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedMotivation = [];
        ctrl.motivation = [
            {
                id: 'Tjene mine egne penge',
                selected: false
            },
            {
                id: 'Lave noget fornuftigt i min fritid',
                selected: false
            },
            {
                id: 'Arbejde med mennesker',
                selected: false
            },
            {
                id: 'Vigtigt for mine fremtidsplaner',
                selected: false
            },
            {
                id: 'Møde nye mennesker og kollegaer',
                selected: false
            },
            {
                id: 'Mere arbejdserfaring',
                selected: false
            },
            {
                id: 'Mere viden om arbejdsmarkedet',
                selected: false
            },
            {
                id: 'Flere kompetencer',
                selected: false
            },
            {
                id: 'Erfaring inden for dette arbejdsområde',
                selected: false
            },
            {
                id: 'Søge nye udfordringer                                                                                                                                                                                                                                                                                       ',
                selected: false
            }
        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedMotivation.length === 3) {
                formData.motivation = selectedMotivation;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="text-answer">'+selectedMotivation[0]+'</span><span class="text-answer">'+selectedMotivation[1]+'</span><span class="text-answer">'+selectedMotivation[2]+'</span>'),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Det er nogle rigtig gode grunde, som du har valgt. <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 sætninger.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onMotivationChange = function onMotivationChange(target){
            if(selectedMotivation.length == 3) {
                target.selected = false;
            }
            selectedMotivation = _.chain(ctrl.motivation).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/motivation-form.component.html',
};
var photoUploader = {
    bindings : {
        addMsg: '&',
        photoUploaderModel: '='
    },
    /**
     * @ngInject
     */
    controller : function PhotoUploaderCtrl ($scope, $rootScope, $element, $sce) {
        
        var ctrl = this;
        ctrl.processing = false;
        var photo = {};

        function init () {
            // console.log("photoUploaderCtrl::init", ctrl.photoUploaderModel, photo);

            if(angular.isDefined(ctrl.photoUploaderModel)){
                ctrl.preview = ctrl.photoUploaderModel.photo;
            }
        }

        function link () {
            var handler = function (e) {
                $scope.$apply(function () {
                    ctrl.fileChanged(e);
                });
            };

            // Attach the handler to the HTML change event 
            $element[0].addEventListener('change', handler, false);
        }

        ctrl.fileChanged = function fileChanged(e){
            // console.log("file_changed: ",  e.target.files);

            ctrl.processing = true;
            // if (!$scope.$$phase) $scope.$digest();
            // if (!$rootScope.$$phase) $rootScope.$digest();

            var file = e.target.files[0];



            loadImage.parseMetaData(
                file,
                function (data) {
                    if (!data.imageHead) {
                        return;
                    }
                    // Combine data.imageHead with the image body of a resized file
                    // to create scaled images with the original image meta data, e.g.:
                    var orientation = data.exif.get('Orientation');
                    var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    // console.log("Orientation:",orientation, data);
                    // console.log("isIos:",isIos);
                    var orientationTransforms = {
                        0 : '',
                        1 : '',
                        2 : 'transform: rotateY(180deg)',
                        3 : 'transform: rotate(180deg)',
                        4 : 'transform: rotate(180deg) rotateY(180deg)',
                        5 : 'transform: rotate(270deg) rotateY(180deg)',
                        6 : 'transform: rotate(90deg)',
                        7 : 'transform: rotate(90deg) rotateY(180deg)',
                        8 : 'transform: rotate(270deg)'
                    };
                    ctrl.orientation = orientation;
                    ctrl.previewTransform = isIos ? '' : orientationTransforms[orientation];
                    // console.log("previewTransform: ",ctrl.previewTransform);

                },
                {
                    maxMetaDataSize: 262144,
                    disableImageHead: false,
                    orientation: true
                }
            );

            
            var reader = new FileReader();
            // Closure to capture the file information.
            reader.onload = (function(theFile) {
                return function(e) {
                    // Render thumbnail.
                    // $('.photoUploader__preview').attr('src',e.target.result); // TODO
                    photo = e.target.result;
                    
                    // Split base64 string and repo intro-stub
                    var base64image = photo.split(",");
                    ctrl.photoUploaderModel = {
                        'base64type' : base64image[0],
                        'base64data' : base64image[1],
                        'type' : file.type,
                        'size' : file.size,
                        'name' : file.name,
                        'orientation' : ctrl.orientation,
                    };
                    ctrl.preview = ctrl.photoUploaderModel.base64type + "," + ctrl.photoUploaderModel.base64data;
                    ctrl.processing = false;
                    // console.log(ctrl.photoUploaderModel);
                    if (!$scope.$$phase) $scope.$digest();
                    if (!$rootScope.$$phase) $rootScope.$digest();

                };
            })(file);
            // Read in the image file as a data URL.
            reader.readAsDataURL(file);

            ctrl.addMsg({
                $event: {
                    content: $sce.trustAsHtml('Flot billede! 💪'),
                    type: 'receive'
                }
            });

        };

        // ctrl.removePhoto = function removePhoto(){
        //     console.log("photoUploaderCtrl.removePhoto");
        //     ctrl.photoUploaderModel = {};
        //     ctrl.preview = "";
        //     document.querySelector(".photoUploader__input").value = "";
        // };

        ctrl.$onInit = init;
        ctrl.$postLink = link;
    },
    templateUrl : './angular/components/photo-uploader.component.html'
};
var smileyForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function SmileyFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedSmilies = [];
        ctrl.smilies = [
            {
                id: 'targeted',
                label: 'Målrettet',
                selected: false,

            },
            {
                id: 'dutiful',
                label: 'Pligtopfyldende',
                selected: false
            },
            {
                id: 'responsible',
                label: 'Ansvarlig',
                selected: false
            },
            {
                id: 'thoughtful',
                label: 'Betænksom',
                selected: false
            },
            {
                id: 'disciplined',
                label: 'Disciplineret',
                selected: false
            },
            {
                id: 'nice',
                label: 'Flink',
                selected: false
            },
            {
                id: 'diligent',
                label: 'Flittig',
                selected: false
            },
            {
                id: 'creative',
                label: 'Kreativ',
                selected: false
            },
            {
                id: 'brave',
                label: 'Modig',
                selected: false
            },
            {
                id: 'careful',
                label: 'Omhyggelig',
                selected: false
            },
            {
                id: 'caring',
                label: 'Omsorgsfuld',
                selected: false
            },
            {
                id: 'imaginative',
                label: 'Opfindsom',
                selected: false
            },
            {
                id: 'productive',
                label: 'Produktiv',
                selected: false
            },
            {
                id: 'punctual',
                label: 'Punktlig',
                selected: false
            },
            {
                id: 'calm',
                label: 'Rolig',
                selected: false
            },
            {
                id: 'funny',
                label: 'Sjov',
                selected: false
            },
            {
                id: 'extrovert',
                label: 'Udadvendt',
                selected: false
            },
            {
                id: 'eloquent',
                label: 'Veltalende',
                selected: false
            },

        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedSmilies.length === 3) {
                formData.smilies = selectedSmilies;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="smiley-icon '+selectedSmilies[0].id+'"></span><span class="smiley-icon '+selectedSmilies[1].id+'"></span><span class="smiley-icon '+selectedSmilies[2].id+'"></span>'),
                        type: 'send'
                    }
                });
                // DataService
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Fedt, du lyder som en cool person 😎 <a href="/din-ansoegning">Godkend dit svar ved at trykke her.</a>'),
                            type: 'receive'
                        }
                    });
                }, 1000);
                
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 smileys.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onSmileyChange = function onSmileyChange(target){
            if(selectedSmilies.length == 3) {
                target.selected = false;
            }
            selectedSmilies = _.chain(ctrl.smilies).filter({'selected':true}).map(function(value){
                var smiley = {
                    id: value.id,
                    label: value.label
                };
                return smiley;
                
            }).value();
            // console.log("onSmileyChange", selectedSmilies);
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/smiley-form.component.html',
};
var stepIndicator = {
    bindings : {
        step: '<',
        totalSteps: '<'
    },
    /**
     * @ngInject
     */
    controller : function StepIndicatorCtrl () {
        
        var ctrl = this;

        function init () {

        }

        function link () {
        }

        function onChanges (changes) {
            
        }

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl : './angular/components/step-indicator.component.html'
};
/**
 * @ngInject
 */
/**
 *
 * we set configuration for angular solution. We set angular routes, so when you come to certain url, we define, which view to show..
 *
 * @param $routeProvider
 * @param fluxProvider
 * @param $authProvider
 * @param $mdThemingProvider
 * @param $mdDateLocaleProvider
 */
function config ($routeProvider, fluxProvider, $authProvider, $mdThemingProvider, $mdDateLocaleProvider) {

    // Angular Material settings
    moment.locale('da');

    $mdDateLocaleProvider.months = moment.months();
    $mdDateLocaleProvider.shortMonths = moment.monthsShort();
    $mdDateLocaleProvider.days = moment.weekdays();
    $mdDateLocaleProvider.shortDays = moment.weekdaysShort();

    $mdThemingProvider.definePalette('jobhajPurple', {
        '50': '453FD0',
        '100': '453FD0',
        '200': '453FD0',
        '300': '453FD0',
        '400': '453FD0',
        '500': '453FD0',
        '600': '453FD0',
        '700': '453FD0',
        '800': '453FD0',
        '900': '453FD0',
        'A100': '453FD0',
        'A200': '453FD0',
        'A400': '453FD0',
        'A700': '453FD0',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('jobhajTurqoise', {
        '50': '29D3BA',
        '100': '29D3BA',
        '200': '29D3BA',
        '300': '29D3BA',
        '400': '29D3BA',
        '500': '29D3BA',
        '600': '29D3BA',
        '700': '29D3BA',
        '800': '29D3BA',
        '900': '29D3BA',
        'A100': '29D3BA',
        'A200': '29D3BA',
        'A400': '29D3BA',
        'A700': '29D3BA',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('jobhajOrange', {
        '50': 'FF8C62',
        '100': 'FF8C62',
        '200': 'FF8C62',
        '300': 'FF8C62',
        '400': 'FF8C62',
        '500': 'FF8C62',
        '600': 'FF8C62',
        '700': 'FF8C62',
        '800': 'FF8C62',
        '900': 'FF8C62',
        'A100': 'FF8C62',
        'A200': 'FF8C62',
        'A400': 'FF8C62',
        'A700': 'FF8C62',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    // Palette adjustment
    $mdThemingProvider.theme('default')
        .primaryPalette('jobhajPurple')
        .accentPalette('jobhajTurqoise')
        .warnPalette('jobhajTurqoise');

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    // Format date 
    $mdDateLocaleProvider.formatDate = function(date) {
        if(date !== undefined){
            return moment(date).locale('da').format('L');
        } else {
            return "";
        }
    };

    fluxProvider.setImmutableDefaults({ immutable: false });

    // Auth config
    // $authProvider provided by satellizer
    $authProvider.loginUrl = '/api/authenticate';
    $authProvider.signupUrl = '/api/signup';
    $authProvider.facebook({
        clientId: window.facebook_client_id,
        url: '/api/authenticate_callback',
        redirectUri: window.location.origin + '/',
    });

    $routeProvider
        .when('/login', {
            templateUrl: '../angular/views/jobhaj-login.html',
        })
        // default login
        .when('/', {
            templateUrl: '../angular/views/jobhaj-application.html',
            controller: HomeCtrl,
            controllerAs: '$ctrl'
        })
        .when('/billede', {
            templateUrl: '../angular/views/application-image.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/info', {
            templateUrl: '../angular/views/application-info.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/personlighed', {
            templateUrl: '../angular/views/application-personality.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/motivation', {
            templateUrl: '../angular/views/application-motivation.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/interesser', {
            templateUrl: '../angular/views/application-interests.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/erfaring', {
            templateUrl: '../angular/views/application-experience.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/sprog', {
            templateUrl: '../angular/views/application-languages.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/arbejdstimer', {
            templateUrl: '../angular/views/application-workhours.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/udseende', {
            templateUrl: '../angular/views/application-look.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .otherwise({redirectTo:'/'});

    /**
     *  these two controllers only responsible for setting pageClass varible.. Look into each view for each route to see,
     *  which controller is called..
     */
    function HomeCtrl($timeout, $animate){
        var ctrl = this;
        
        $timeout(function(){
            $animate.enabled(true);
        });
        ctrl.pageClass = 'home';
    }

    function DetailCtrl($timeout, $animate){
        var ctrl = this;

        $timeout(function(){
            $animate.enabled(true);
        });
        ctrl.pageClass = 'detail';
    }

}
/**
 * @ngInject
 */
function run($rootScope, $window, $animate, $auth, flux, userStore, actions, $timeout, Tracking) {

	$animate.enabled(false);
	var authenticated = false;
	var registeredUserDimension = false;

	// we check first if user is Authenticated.. if not, we get the user.
	if($auth.isAuthenticated()){
		flux.dispatch('GET_USER');
		Tracking.setDimension("dimension1", "yes");
	}

	$rootScope.$on('$routeChangeSuccess', function(event, next, current) { 
		var path = next.originalPath == "/" ? location.pathname : location.pathname + next.originalPath;
		Tracking.trackPage(path);
	});

	// Logic for handling expired sessions on window focus
	function authChecker() {
		// Check if user was previously authenticated in this session - if so let's run the logout routine to avoid a user working on their data without being authenticated
		if(authenticated && !$auth.isAuthenticated()){
			// console.log("RUN.JS We WERE authenticated but not anymore, let's logout");
			authenticated = false;
			flux.dispatch('LOGOUT_USER', {});
		} else if($auth.isAuthenticated()){
			// console.log("RUN.JS Yes, we are authenticated. Let's remember this")
			authenticated = true;
		}
	}

	// Register user dimension once
	function onUserUpdated() {
		var user = userStore.getUser();
		if(!registeredUserDimension && angular.isDefined(user.id)){
			Tracking.setDimension("dimension2", user.id);
			registeredUserDimension = true;
		}
	}

	// listening to userStore object.. if it changes, run onUserUpdated() which impacts local scope
	$rootScope.$listenTo(userStore, ['user'], onUserUpdated);

	// we need to have this event just so we can logout user if he has leaved a page for some time and session is expired..
	// It checks it every time window is in focus.
	angular.element($window).bind('focus', function() {
		authChecker();
	});

	// check if we are authenticated on application load
	authChecker();
}
/**
 * @ngInject
 */
function DialogCtrl($scope, $mdDialog, $location, $auth, $timeout, userStore, flux, actions, state, successBtnState, Tracking){
	var ctrl = this;
    ctrl.state = state;
	ctrl.successBtnState = successBtnState;
	
	ctrl.hide = function cancel() {
        // console.log("hide");
		$mdDialog.hide().finally(function() {
            // In some events the overflow:hidden on body is not removed so let's just remove it here - not pretty but works
            document.body.style.overflow = null;
        });
	};
	ctrl.cancel = function hide() {
        // console.log("cancel");
        $mdDialog.cancel().finally(function() {
            // In some events the overflow:hidden on body is not removed so let's just remove it here - not pretty but works
            document.body.style.overflow = null;
        });
    };
    ctrl.toggleDialogState = function toggleDialogState(state){
    	ctrl.state = state;
        ctrl.wrongCredentials = false;
        ctrl.formData = {};
    };

    ctrl.createUser = function createUser(isValid) {
        if(isValid) {
            $auth.signup({
                email: ctrl.formData.email,
                password: ctrl.formData.password
            }).then(onSignupSuccess)
            .catch(onSignupError);
        }
    };

    ctrl.autenticateUserFb = function autenticateUserFb() {
        flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
    };

    ctrl.autenticateUser = function autenticateUser(isValid) {
        if(isValid) {
            flux.dispatch('AUTHENTICATE_USER', {'type' : 'email', 'email' : ctrl.formData.email, 'password' : ctrl.formData.password}); 
        }
    };

    ctrl.continueApplication = function continueApplication() {
        if($auth.isAuthenticated()){
            if(window.location.pathname === "/") {
                window.location.href = '/din-ansoegning#!/';
            } else {
                window.location.reload();
            }
        } 
    };

    ctrl.seeApplication = function seeApplication(){
        var win = window.open('/min-ansoegning?token=' + $auth.getToken(), '_blank');
        win.focus();
        window.location.reload();
    };

    function onSignupSuccess(response){
        // console.log("onSignupSuccess", response, userStore.getUser());
    	$auth.setToken(response.data.token);
        flux.dispatch(actions.UPDATE_USER);
        ctrl.state = 'success';
        Tracking.trackEvent("user","signup","");
    }

    function onSignupError(response){
    	// console.log("Der opstod en fejl.", response);
        ctrl.wrongCredentials = true;
    }

    function authCallback(response){
        // console.log("authCallback", response);
        if($auth.isAuthenticated()){

            Tracking.setDimension("dimension1", "yes");

            if(window.location.pathname === "/") {
                window.location.href = '/din-ansoegning#!/';
            } else {
                // window.location.reload(); // We do not need a full reload.
                ctrl.hide();
            }
        } 
    }

    function loginCallback(data) {
        if(!_.isEmpty(data)) {
            ctrl.wrongCredentials = true;
            if(!$scope.$$phase) {
                $scope.$digest();
            }
        }  
    }

    // $scope.$listenTo(userStore, ['user'], authCallback);
    $scope.$listenTo(userStore, ['login'], loginCallback);
    $scope.$listenTo(userStore, ['authenticated'], authCallback);

}
/**
 * @ngInject
 */
function HelpDialogCtrl($mdDialog){
	var ctrl = this;
	
	ctrl.hide = function() {
		$mdDialog.hide();
	};
	ctrl.cancel = function() {
      $mdDialog.cancel();
    };
}
/**
 * @ngInject
 */
function SendDialogCtrl($scope, $mdDialog, $location, $auth, userStore, flux, actions){
	var ctrl = this;
    ctrl.user = userStore.getUser();
    if(_.size(ctrl.user) < 13) {
        ctrl.state = 'not-done';
    } else {
        ctrl.state = 'done';
    }

	
	ctrl.hide = function() {
		$mdDialog.hide();
	};
	ctrl.cancel = function() {
      $mdDialog.cancel();
    };
}
/**
 * @ngInject
 */
function showJobMapDialogCtrl($mdDialog){
	var ctrl = this;
	ctrl.cancel = function() {
      $mdDialog.cancel();
    };
}
/**
 * @ngInject
 * Compiles input with html tags in and makes Angular directives as "ng-click" available in scope.
 */

function compileHtmlWithDirectives($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                return scope.$eval(attrs.compile);
            },
            function(value) {
                element.html(value.toString());
                $compile(element.contents())(scope);
            }
        )};
}
/**
 * @ngInject
 */

function inlineSvg() {

	function getTemplateUrl (elem, attr) {
		return attr.path;
	} 

	return {
		restrict: "E",
		templateUrl: getTemplateUrl,
		replace : true
	}
}
/**
 * @ngInject
 */

function keepScrollPos($route, $window, $timeout, $location, $anchorScroll) {

	return {
		restrict: "A",
		link : link
	};

	function link (scope, elem, attrs) {

		var scrollPosCache = {};

		scope.$on('$routeChangeStart', function() {
			// store scroll position for the current view
			if ($route.current) {
				scrollPosCache[$route.current.loadedTemplateUrl] = [ $window.pageXOffset, $window.pageYOffset ];
			}
	    });

	    scope.$on('$routeChangeSuccess', function() {
			// if hash is specified explicitly, it trumps previously stored scroll position
			if ($location.hash()) {
				$anchorScroll();

			// else get previous scroll position; if none, scroll to the top of the page
			} else {
				var prevScrollPos = scrollPosCache[$route.current.loadedTemplateUrl] || [ 0, 0 ];
				$timeout(function() {
					$window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
				}, 0);
			}
	    });


	}
}
/**
 * @ngInject
 */

function login() {

	function LoginController($scope, $auth, $element, $attrs, $mdDialog, flux, actions){
		// console.log("LoginController", $mdDialog);
		this.isAuthenticated = $auth.isAuthenticated();

		this.showLogin = function showLogin(ev) {
		    $mdDialog.show({
				controller: DialogCtrl,
				controllerAs: '$ctrl',
				templateUrl: './angular/views/dialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: false,
				locals: {
                    state: 'login',
                    successBtnState: 'frontpage'
                }
		    });
		};

		this.facebookAuth = function facebookAuth(){
	    	// console.log("Login with facebook");
	    	flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
	    };
	}
	
	return {
		controller: LoginController,
		controllerAs: 'login',
		bindToController: true,
		restrict: "A"
	};
}
/**
 * @ngInject
 */

function menu() {

	function MenuController($scope, $element, $attrs, $location, $auth, $mdDialog, userStore, flux, actions, Tracking){
		// console.log("menuController");

		var ctrl = this;
		ctrl.isAuthenticated = false; 
		$scope.$listenTo(userStore, ['user'], authCallback);

		function toggleNav() {
			$element[0].querySelector('.nav').classList.toggle('open');
		}

		function authCallback(response){
			// console.log("authCallback", response);

			ctrl.isAuthenticated = $auth.isAuthenticated();
			// console.log("isAuthenticated", ctrl.isAuthenticated);

			if (!$scope.$$phase) $scope.$apply();
		}

		this.login = function login(ev) {
			Tracking.trackEvent("menu", "log ind", "");

		    $mdDialog.show({
				controller: DialogCtrl,
				controllerAs: '$ctrl',
				templateUrl: './angular/views/dialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: false,
				locals: {
				    state: 'login',
				    successBtnState: 'frontpage'
				}
		    });
			toggleNav();
		};

	    this.logout = function logout()
	    {
	    	Tracking.trackEvent("menu", "log ud", "");
	    	flux.dispatch('LOGOUT_USER', {});
	    	// console.log("Logout");
	    	toggleNav();
	    	window.location.href = "/";
	    };
	}

	function link (scope, elem, attrs) {
	    var btn = elem[0].querySelector('.btn-menu');
	    var close = elem[0].querySelector('.btn-close');
	    var backBtn = elem[0].querySelector('.btn-back');

	    btn.addEventListener('click', onMenuClick);
	    close.addEventListener('click', onMenuClick);
	    backBtn.addEventListener('click', onBackClick);

	    function onMenuClick(){
	    	elem[0].querySelector('.nav').classList.toggle('open');
	    	if(elem[0].querySelector('.nav').classList.contains('open')) {
	    		document.body.style.overflow = "hidden";
	    		if(Modernizr.touchevents) {
	    			document.ontouchmove = function (e) {
	    			  e.preventDefault();
	    			};
	    		}
	    	} else {
	    		document.body.style.overflow = "auto";
	    		if(Modernizr.touchevents) {
	    			document.ontouchmove = function (e) {
	    			  return true;
	    			};
	    		}
	    	}
	    }

	    function onBackClick(){
	    	if(window.location.hash === '#!/') {
	    		window.location.href = '/';
	    	} else {
	    		window.history.back();
	    	}
	    }

	}

	return {
		controller: MenuController,
		controllerAs: 'menuCtrl',
		bindToController: true,
		restrict: "A",
		link : link
	};
}
/**
 * @ngInject
 */

function momentize () {
    function link (scope, elem, attrs) {
        moment.locale(currentLang);
        // console.log("momentize", moment(attrs.momentize.toString(), attrs.momentizeParse));
        function onUpdate(){
            elem.text(moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        }
        attrs.$observe('momentize', onUpdate);
        attrs.$observe('momentizeDisplay', onUpdate);
    }

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */

function passwordMatch() {

	function link(scope, element, attributes, ngModel) {
		// console.log('scope', attributes);

		ngModel.$validators.matchPassword = function(modelValue, viewValue) {
			if (modelValue !== attributes.passwordMatch) return false;
			return true
		}

		attributes.$observe('passwordMatch', function() {
			ngModel.$validate();
		})

	}

	return {
		require: 'ngModel',
		link: link,
	};
}
/**
 * @ngInject
 * Takes a class and does a jquery animate on it.
 */

function scrollTo() {
  return {
    restrict: "A",
    link: function link(scope, elem, attrs) {
      elem[0].addEventListener("click", function(event) {
        // console.log("scrollTo", attrs.scrollTo);
        $("html, body").animate(
          { scrollTop: $("." + attrs.scrollTo).offset().top },
          "slow"
        );
      });
    }
  };
}

/**
 * @ngInject
 */

function trackEvent() {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            
            var eventPath = attrs.trackEvent;
            var eventArray = eventPath.split('/');

            var eventCategory = "";
            var eventAction = "";
            var eventLabel = "";

            if (typeof eventArray[0] != 'undefined') {
                eventCategory = eventArray[0].toString();            
            }

            if (typeof eventArray[1] != 'undefined') {
                eventAction = eventArray[1].toString();
            }

            if (typeof eventArray[2] != 'undefined') {
                // console.log(eventArray.length, eventArray);
                if(eventArray.length > 2){
                    angular.forEach(eventArray, function(value, key){
                        if(key >= 2){
                            eventLabel += value+"/";
                        }
                    });
                } else {
                    eventLabel = eventArray[2].toString();
                }
            }

            elem[0].addEventListener('click', function(event){
                // console.log("trackEvent: \n"+eventCategory+"\n"+eventAction+"\n"+eventLabel)
                try {
                    ga('send', 'event', eventCategory, eventAction, eventLabel);
                } catch(e){
                    console.warn("trackEvent: Could not track event: \n"+eventCategory+"\n"+eventAction+"\n"+eventLabel)
                }
            });

        }
    }
}
/**
 * @ngInject
 */
function videoResizer () {

    function onWindowResize () {
        iframe.style.height = el.offsetWidth/ratio+"px";

    }

    function link (scope, elem, attrs) {
        el = elem[0];
        if (el.classList.contains('video')) {
            iframe = el.querySelector('iframe');
            ratio = iframe.getAttribute("width") / iframe.getAttribute("height");
            // console.log(ratio);
            window.addEventListener('resize', _.debounce(onWindowResize, 250));
            onWindowResize();
        }
    }

    var el, iframe, ratio;

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */
function Breakpoints () {
    var breakpoints = {
        small: window.matchMedia('(min-width: 600px)'),
        medium: window.matchMedia('(min-width: 992px)'),
        large: window.matchMedia('(min-width: 1350px)')
    };
    var api = {};
    api.matches = function matches(breakpoint) {
        return (breakpoints[breakpoint].matches);
    };
    api.getLayout = function getLayout() {
        if (breakpoints.large.matches) return 'large';
        if (breakpoints.medium.matches) return 'medium';
        if (breakpoints.small.matches) return 'small';
        return 'x-small';
    };
    return api;
}
/**
 * @ngInject
 */
/**
 *  we user this function to call Laravel API from Javascript and send data back to UserStore..
 *
 */
function DataService($q, $http) {
    var api = {};

    api.getUser = function() {
        return $http.get('/api/authenticate');
    };

    api.updateUser = function(data) {
        return $http.put(
            '/api/authenticate',
            data
        );
    };

    api.deleteUser = function() {
        return $http.delete(
            '/api/authenticate',
            {}
        );
    };

    return api;
}
/**
 * @ngInject
 */

function Tracking() {
    var api = {};

    api.trackPage = function trackPage(path){
        if(typeof ga === "function"){
            ga('send', 'pageview', path);
        } else {
            console.warn("ga is not defined. GA data is not tracked:\nC: "+path);
        }
    }

    api.trackEvent = function trackEvent(category, action, label){
        if(typeof ga === "function"){
            ga('send', 'event', category, action, label);
        } else {
            console.warn("ga is not defined. GA data is not tracked:\nC: "+category+"\nA: "+action+"\nL: "+label);
        }
    }

    api.setDimension = function setDimension(dimension, value){
        // console.log("SET DIMENSION: ",dimension,value)
        if(typeof ga === "function"){
            ga('set', dimension, value);
        } else {
            console.warn("ga is not defined. GA dimension not set:\nD: "+dimension+"\nV: "+value);
        }
    }

    return api;
}
/**
 * @ngInject
 */
/**
 * create store object, which is responsible for saving and getting user data - login part..
 * Store object has methods like authenticateUser, getUser and so on.. So in js code of Angular components, we call
 * flux.dispatch(actions.UPDATE_USER, formData); so we call actions.UPDATE_USER action which is calls userUpdate
 * function (store.handlers[actions.UPDATE_USER] = 'updateUser';) and in this function we call DataService (DataService.updateUser(formData))
 * to save data in the database.
 *
 *
 * @param actions - flux actions
 * @param $auth
 * @param $sessionStorage - object to save data in Session
 * @param DataService
 * @returns store object
 */
function userStore (actions, $auth, $sessionStorage, DataService) {

	function onGetUserSuccess (response) {
        // console.log("USER-STORE.jS onGetUserSuccess func", response.data);
        // $('#test').append(JSON.stringify(response.data)); // if data is comming back as JSON, we have to
		// make it to a string before we can appent it to html.

	    // Merge existing user data (if data is not from database == has no id) with whatever data the user already has client side
	    if(angular.isUndefined(store.session.user.id) && Object.keys(store.session.user).length > 0){

	    	angular.bind(this, store.updateUser(store.session.user) ); // db request will be fired but callback doesn't work due to scope confusion

	    	// Merge local data with database data
	    	angular.extend(response.data, store.session.user);
	    }

        store.session.user = response.data;
        this.state.set(['user'], response.data);
        this.state.set(['authenticated'], true);
    }
	function onGetUserError (response) {
		// console.log(response);
	}

	function onUpdateUserSuccess (response) {
        // console.log("USER-STORE.jS onUpdateUserSuccess func !!!");
        // console.log("USER-STORE.jS response.data");
        // console.log(response.data);
        // $('#test').append(response.data);

		if(angular.isUndefined(this.state)) return;

		// When we update a user, we need to read new user info from db and update all scopes.
		this.getUser();
	}
	function onUpdateUserError (response) {
		// console.log("userStore.onUpdateUserError");
		// console.log(response.data);
	}

	function onDeleteSuccess(response){
		alert("Din bruger er nu slettet.");
		store.session.user = {};
		this.state.set(['user'], {});
		$auth.logout();
	}
	function onDeleteError(response){
		alert("Der opstod en fejl. Din bruger blev ikke slettet.");
	}

	var store = {};
	store.handlers = {};
    store.handlers[actions.AUTHENTICATE_USER] = 'authenticateUser';
    store.handlers[actions.GET_USER] = 'getUser';
    store.handlers[actions.UPDATE_USER] = 'updateUser';
    store.handlers[actions.LOGOUT_USER] = 'logoutUser';
    store.handlers[actions.DELETE_USER] = 'deleteUser';

    store.session = $sessionStorage;

    if(angular.isUndefined(store.session.user)) {
    	store.session.user = {};
    }

    store.initialize = function initialize(){
		this.state = this.immutable({
			user: {},
			authenticated: false
		});	
	};

	store.authenticateUser = function authenticateUser(data){

		switch(data.type){
			case 'facebook':
				$auth.authenticate('facebook')
					.then( angular.bind(this, store.getUser) )
					.catch( angular.bind(this,function(response) {
						alert("Der opstod en fejl.");
						// console.log("facebook auth error",response);
					}));
				break;
			case 'email':
				var user = {
					email: data.email,
					password: data.password
				};
				
				$auth.login(user)
					.then( angular.bind(this, store.getUser) )
					.catch( angular.bind(this,function(response) {
						// console.log("catch: ",response);
						if(response.status === 401) {
							this.state.set(['login'], false);
						}
					}));
				break;
		}
	};

	store.getUser = function getUser(){
		DataService.getUser().then(angular.bind(this,onGetUserSuccess), angular.bind(this, onGetUserError));
	};

	store.updateUser = function updateUser(formData){
		// console.log("USER-STORE.jS updateUser func");
		// console.log("formData");
		// console.log(formData);

		if(!$auth.isAuthenticated()){
			// If user is not authenticated we only work on the client data
			if(formData) {
                angular.extend(store.session.user, formData);
				this.state.set(['user'], store.session.user );
			}
		} else {
            if(!formData) {
				formData = store.session.user;
			}
			// call updateUser func. on DataService object from services/DataService.js
			// on success call onUpdateUserSuccess func from this file
			DataService.updateUser(formData).then(angular.bind(this,onUpdateUserSuccess), angular.bind(this, onUpdateUserError));
		}

	};

	store.logoutUser = function logoutUser(){
		$auth.logout();

		store.session.user = {};
		this.state.set(['user'], {});

		window.location.href = "/";
	};

	store.deleteUser = function deleteUser() {
		DataService.deleteUser()
		    .then(angular.bind(this,onDeleteSuccess), angular.bind(this, onDeleteError));
	};

	store.exports = {};

    store.exports.getUser = function getUser () {
    	return store.session.user;
    };

	return store;

}
// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3_3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0.3
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 */

/**
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'imagePath': (string) The base URL where the images representing
 *                  clusters will be found. The full URL will be:
 *                  {imagePath}[1-5].{imageExtension}
 *                  Default: '../images/m'.
 *     'imageExtension': (string) The suffix for images URL representing
 *                       clusters will be found. See _imagePath_ for details.
 *                       Default: 'png'.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);
  this.map_ = map;

  /**
   * @type {Array.<google.maps.Marker>}
   * @private
   */
  this.markers_ = [];

  /**
   *  @type {Array.<Cluster>}
   */
  this.clusters_ = [];

  this.sizes = [53, 56, 66, 78, 90];

  /**
   * @private
   */
  this.styles_ = [];

  /**
   * @type {boolean}
   * @private
   */
  this.ready_ = false;

  var options = opt_options || {};

  /**
   * @type {number}
   * @private
   */
  this.gridSize_ = options['gridSize'] || 60;

  /**
   * @private
   */
  this.minClusterSize_ = options['minimumClusterSize'] || 2;


  /**
   * @type {?number}
   * @private
   */
  this.maxZoom_ = options['maxZoom'] || null;

  this.styles_ = options['styles'] || [];

  /**
   * @type {string}
   * @private
   */
  this.imagePath_ = options['imagePath'] ||
      this.MARKER_CLUSTER_IMAGE_PATH_;

  /**
   * @type {string}
   * @private
   */
  this.imageExtension_ = options['imageExtension'] ||
      this.MARKER_CLUSTER_IMAGE_EXTENSION_;

  /**
   * @type {boolean}
   * @private
   */
  this.zoomOnClick_ = true;

  if (options['zoomOnClick'] != undefined) {
    this.zoomOnClick_ = options['zoomOnClick'];
  }

  /**
   * @type {boolean}
   * @private
   */
  this.averageCenter_ = false;

  if (options['averageCenter'] != undefined) {
    this.averageCenter_ = options['averageCenter'];
  }

  this.setupStyles_();

  this.setMap(map);

  /**
   * @type {number}
   * @private
   */
  this.prevZoom_ = this.map_.getZoom();

  // Add the map event listeners
  var that = this;
  google.maps.event.addListener(this.map_, 'zoom_changed', function() {
    // Determines map type and prevent illegal zoom levels
    var zoom = that.map_.getZoom();
    var minZoom = that.map_.minZoom || 0;
    var maxZoom = Math.min(that.map_.maxZoom || 100,
                         that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom);
    zoom = Math.min(Math.max(zoom,minZoom),maxZoom);

    if (that.prevZoom_ != zoom) {
      that.prevZoom_ = zoom;
      that.resetViewport();
    }
  });

  google.maps.event.addListener(this.map_, 'idle', function() {
    that.redraw();
  });

  // Finally, add the markers
  if (opt_markers && (opt_markers.length || Object.keys(opt_markers).length)) {
    this.addMarkers(opt_markers, false);
  }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
  return (function(object) {
    for (var property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
  this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size
    });
  }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }

  this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
  this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function() {
  return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function() {
  return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function() {
  return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
  return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
  return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function(markers, numStyles) {
  var index = 0;
  var count = markers.length;
  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index
  };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
  this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function() {
  return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
  if (markers.length) {
    for (var i = 0, marker; marker = markers[i]; i++) {
      this.pushMarkerTo_(marker);
    }
  } else if (Object.keys(markers).length) {
    for (var marker in markers) {
      this.pushMarkerTo_(markers[marker]);
    }
  }
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
  marker.isAdded = false;
  if (marker['draggable']) {
    // If the marker is draggable add a listener so we update the clusters on
    // the drag end.
    var that = this;
    google.maps.event.addListener(marker, 'dragend', function() {
      marker.isAdded = false;
      that.repaint();
    });
  }
  this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        index = i;
        break;
      }
    }
  }

  if (index == -1) {
    // Marker is not in our list of markers.
    return false;
  }

  marker.setMap(null);

  this.markers_.splice(index, 1);

  return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  } else {
   return false;
  }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
  // create a local copy of markers if required
  // (removeMarker_ modifies the getMarkers() array in place)
  var markersCopy = markers === this.getMarkers() ? markers.slice() : markers;
  var removed = false;

  for (var i = 0, marker; marker = markersCopy[i]; i++) {
    var r = this.removeMarker_(marker);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function(ready) {
  if (!this.ready_) {
    this.ready_ = ready;
    this.createClusters_();
  }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
  return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function() {
  return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function(map) {
  this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
  return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(size) {
  this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function() {
  return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function(size) {
  this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
  this.resetViewport(true);

  // Set the markers a empty array.
  this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function(opt_hide) {
  // Remove all the clusters
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    cluster.remove();
  }

  // Reset the markers to not be added and to be invisible.
  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }

  this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function() {
  var oldClusters = this.clusters_.slice();
  this.clusters_.length = 0;
  this.resetViewport();
  this.redraw();

  // Remove the old clusters.
  // Do it in a timeout so the other clusters have been drawn first.
  window.setTimeout(function() {
    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
      cluster.remove();
    }
  }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function() {
  this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
  if (!p1 || !p2) {
    return 0;
  }

  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  var pos = marker.getPosition();
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    var center = cluster.getCenter();
    if (center) {
      var d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    var cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function() {
  if (!this.ready_) {
    return;
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
      this.map_.getBounds().getNorthEast());
  var bounds = this.getExtendedBounds(mapBounds);

  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      this.addToClosestCluster_(marker);
    }
  }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
  this.markerClusterer_ = markerClusterer;
  this.map_ = markerClusterer.getMap();
  this.gridSize_ = markerClusterer.getGridSize();
  this.minClusterSize_ = markerClusterer.getMinClusterSize();
  this.averageCenter_ = markerClusterer.isAverageCenter();
  this.center_ = null;
  this.markers_ = [];
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
      markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) != -1;
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
  }
  return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function(marker) {
  if (this.isMarkerAlreadyAdded(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l-1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l-1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  var len = this.markers_.length;
  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
    // Min cluster size not reached so show the marker.
    marker.setMap(this.map_);
  }

  if (len == this.minClusterSize_) {
    // Hide the markers that were showing.
    for (var i = 0; i < len; i++) {
      this.markers_[i].setMap(null);
    }
  }

  if (len >= this.minClusterSize_) {
    marker.setMap(null);
  }

  this.updateIcon();
  return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function() {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function() {
  this.clusterIcon_.remove();
  this.markers_.length = 0;
  delete this.markers_;
};


/**
 * Returns the number of markers in the cluster.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function() {
  return this.markers_.length;
};


/**
 * Returns a list of the markers in the cluster.
 *
 * @return {Array.<google.maps.Marker>} The markers in the cluster.
 */
Cluster.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function() {
  return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function() {
  return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function() {
  var zoom = this.map_.getZoom();
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz && zoom > mz) {
    // The zoom is greater than our max zoom so show all the markers in cluster.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.setMap(this.map_);
    }
    return;
  }

  if (this.markers_.length < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.setSums(sums);
  this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.styles_ = styles;
  this.padding_ = opt_padding || 0;
  this.cluster_ = cluster;
  this.center_ = null;
  this.map_ = cluster.getMap();
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 */
ClusterIcon.prototype.triggerClusterClick = function() {
  var markerClusterer = this.cluster_.getMarkerClusterer();

  // Trigger the clusterclick event.
  google.maps.event.trigger(markerClusterer.map_, 'clusterclick', this.cluster_);

  if (markerClusterer.isZoomOnClick()) {
    // Zoom into the cluster.
    this.map_.fitBounds(this.cluster_.getBounds());
  }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function() {
  this.div_ = document.createElement('DIV');
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.innerHTML = this.sums_.text;
  }

  var panes = this.getPanes();
  panes.overlayMouseTarget.appendChild(this.div_);

  var that = this;
  google.maps.event.addDomListener(this.div_, 'click', function() {
    that.triggerClusterClick();
  });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= parseInt(this.width_ / 2, 10);
  pos.y -= parseInt(this.height_ / 2, 10);
  return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function() {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + 'px';
    this.div_.style.left = pos.x + 'px';
    this.div_.style.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
  }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function() {
  if (this.div_) {
    this.div_.style.display = 'none';
  }
  this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function() {
  if (this.div_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.style.display = '';
  }
  this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function() {
  this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function() {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function(sums) {
  this.sums_ = sums;
  this.text_ = sums.text;
  this.index_ = sums.index;
  if (this.div_) {
    this.div_.innerHTML = sums.text;
  }

  this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function() {
  var index = Math.max(0, this.sums_.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style['url'];
  this.height_ = style['height'];
  this.width_ = style['width'];
  this.textColor_ = style['textColor'];
  this.anchor_ = style['anchor'];
  this.textSize_ = style['textSize'];
  this.backgroundPosition_ = style['backgroundPosition'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
  this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
  var style = [];
  style.push('background-image:url(' + this.url_ + ');');
  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
  style.push('background-position:' + backgroundPosition + ';');

  if (typeof this.anchor_ === 'object') {
    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
        this.anchor_[0] < this.height_) {
      style.push('height:' + (this.height_ - this.anchor_[0]) +
          'px; padding-top:' + this.anchor_[0] + 'px;');
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
          'px;');
    }
    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
        this.anchor_[1] < this.width_) {
      style.push('width:' + (this.width_ - this.anchor_[1]) +
          'px; padding-left:' + this.anchor_[1] + 'px;');
    } else {
      style.push('width:' + this.width_ + 'px; text-align:center;');
    }
  } else {
    style.push('height:' + this.height_ + 'px; line-height:' +
        this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
  }

  var txtColor = this.textColor_ ? this.textColor_ : 'black';
  var txtSize = this.textSize_ ? this.textSize_ : 11;

  style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
      pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
      txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
  return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
// var window = window || {};
// window['MarkerClusterer'] = MarkerClusterer;
// MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
// MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
// MarkerClusterer.prototype['clearMarkers'] =
//     MarkerClusterer.prototype.clearMarkers;
// MarkerClusterer.prototype['fitMapToMarkers'] =
//     MarkerClusterer.prototype.fitMapToMarkers;
// MarkerClusterer.prototype['getCalculator'] =
//     MarkerClusterer.prototype.getCalculator;
// MarkerClusterer.prototype['getGridSize'] =
//     MarkerClusterer.prototype.getGridSize;
// MarkerClusterer.prototype['getExtendedBounds'] =
//     MarkerClusterer.prototype.getExtendedBounds;
// MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
// MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
// MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
// MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
// MarkerClusterer.prototype['getTotalClusters'] =
//     MarkerClusterer.prototype.getTotalClusters;
// MarkerClusterer.prototype['getTotalMarkers'] =
//     MarkerClusterer.prototype.getTotalMarkers;
// MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
// MarkerClusterer.prototype['removeMarker'] =
//     MarkerClusterer.prototype.removeMarker;
// MarkerClusterer.prototype['removeMarkers'] =
//     MarkerClusterer.prototype.removeMarkers;
// MarkerClusterer.prototype['resetViewport'] =
//     MarkerClusterer.prototype.resetViewport;
// MarkerClusterer.prototype['repaint'] =
//     MarkerClusterer.prototype.repaint;
// MarkerClusterer.prototype['setCalculator'] =
//     MarkerClusterer.prototype.setCalculator;
// MarkerClusterer.prototype['setGridSize'] =
//     MarkerClusterer.prototype.setGridSize;
// MarkerClusterer.prototype['setMaxZoom'] =
//     MarkerClusterer.prototype.setMaxZoom;
// MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
// MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

// Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
// Cluster.prototype['getSize'] = Cluster.prototype.getSize;
// Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;
//
// ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
// ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
// ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;

Object.keys = Object.keys || function(o) {
    var result = [];
    for(var name in o) {
        if (o.hasOwnProperty(name))
          result.push(name);
    }
    return result;
};

if (typeof module == 'object') {
  module.exports = MarkerClusterer;
}
})(window.angular);